import { UserModel } from "./user.model";

const INFO_BY_PROVIDER = {
  'google.com' : {
    family_name: 'lastName',
    given_name: 'firstName'
  },
  'default' :{}
}

export namespace AuthModel {
  export const getProviderUser = (profile:any, providerId:'google.com'| 'default') => {
    const fromProvider:any = INFO_BY_PROVIDER[providerId];

    const userInfo = {} as any;
    for (const key in fromProvider) {
      userInfo[fromProvider[key]] = profile[key]
    }
    return userInfo;
  }
}

